module.exports = __webpack_public_path__ + "img/bg.3d72db63.png";